import { Rate } from "@redotech/fx";
import { LoadState } from "@redotech/react-util/load";
import { useEffect, useState } from "react";
import { useFx } from "./fx-context";
import { WatchRateRef } from "./fx-subscription-store";

export type { WatchRateRef } from "./fx-subscription-store";

/**
 * Subscribe to a live rate through the provider's shared subscription store.
 * Pass `undefined` to watch nothing — the hook stays inert and resolves to a
 * non-pending empty state.
 */
export function useWatchRate(ref: WatchRateRef | undefined): LoadState<Rate> {
  const { subscribe } = useFx();
  const [state, setState] = useState<LoadState<Rate>>({
    pending: ref !== undefined,
  });

  useEffect(() => {
    if (!ref) {
      setState({ pending: false });
      return;
    }
    setState({ pending: true });
    return subscribe(
      { base: ref.base, quote: ref.quote, source: ref.source },
      setState,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref?.base, ref?.quote, ref?.source, subscribe]);

  return state;
}
